// this adds some polyfills to the browser which Webpack does but esbuild doesn't
// esbuild is Vite's build tool when running in dev mode
if (typeof (window as any).global === "undefined") {
  (window as any).global = window;
}

// this is a workaround so the polyfills file is read properly
export {};
